import {createApp} from 'vue';
import i18n from '../plugins/i18n';
import {SavedConfigurationReminder, CartReminder} from '@webstacz/shop-components';
import {Device, getDeviceType} from '../plugins/Helpers';

document.addEventListener('DOMContentLoaded', async () => {
    const elementId = 'reminder';
    const reminder = document.getElementById(elementId);
    if (reminder !== null) {
        if (
            getDeviceType() === Device.SMARTPHONE
            || Cookies.get('reminder_closed') === '1'
            || Cookies.get('toast-closed') === '1'
        ) {
            // if old cookies exists, remove it and use the new one
            if (
                Cookies.get('toast-closed')
                && (
                    typeof Cookies.get('reminder_closed') === 'undefined'
                    || Cookies.get('reminder_closed') === null
                )
            ) {
                // set old cookies as invalid
                Cookies.set('toast-closed', null, -1);
                Cookies.set('toast-cart-delayed', null, -1);
                closeReminder();
            }

            reminder.remove();
            return;
        }

        if (await checkCartReminder(reminder, elementId)) {
            return;
        }
        await checkLastConfigurationReminder(reminder, elementId);

        recalculatePosition();
    }
});

document.addEventListener('onReminderClose', () => {
    closeReminder();
});

const checkCartReminder = async (reminder, elementId) => {
    if (!reminder.dataset.cartUrl || !reminder.dataset.cartItemsCount) {
        return false;
    }

    const link = reminder.dataset.cartUrl;
    const cartHash = Cookies.get('customer_cart');
    const cartItemsCount = parseInt(reminder.dataset.cartItemsCount)

    if (!cartHash || cartHash === 'false') {
        return false;
    }

    const reminderCart = JSON.parse(window.localStorage?.getItem('cart_reminder') ?? '{}');
    if (reminderCart.identifier !== cartHash || reminderCart.cartItemsCount < cartItemsCount) {
        try {
            window.localStorage?.setItem('cart_reminder', JSON.stringify({
                identifier: cartHash,
                cartItemsCount: cartItemsCount,
                createdAt: (new Date()).getTime(),
            }));
        } catch {}
        return true;
    }

    if (!reminderCart.cartItemsCount || reminderCart.cartItemsCount !== cartItemsCount) {
        reminderCart.cartItemsCount = cartItemsCount;
        try {
            window.localStorage?.setItem('cart_reminder', JSON.stringify(reminderCart));
        } catch {}
    }

    if (reminderCart.cartItemsCount === 0) {
        return false;
    }

    if (!checkReminderDelay(reminderCart.createdAt)) {
        return true;
    }

    const app = createApp({
        components: {
            CartReminder,
        },
        template: `
            <CartReminder
                :link="link"
            />
        `,
        setup() {
            return {
                link,
            };
        },
    });

    app.use(i18n);
    app.mount('#' + elementId);

    return true;
};

const checkLastConfigurationReminder = async (reminder, elementId) => {
    let locale = reminder.dataset.locale;

    const lastConfiguration = window.localStorage?.getItem('last_configuration');
    if (!lastConfiguration) {
        return false;
    }

    const configurationData = JSON.parse(lastConfiguration);

    if (!checkReminderDelay(configurationData.createdAt)) {
        return false;
    }

    if (!configurationData.server_data) {
        configurationData.server_data = {};
    }

    if (!configurationData.server_data[locale]) {
        let configurationUrl = reminder.dataset.configurationUrl;
        if (!configurationUrl) {
            return false;
        }

        if (typeof configurationData.identifier !== 'undefined') {
            configurationUrl = configurationUrl.replace('identifier', configurationData.identifier);

            const response = await (await fetch(configurationUrl, { credentials: 'include' })).json();
            configurationData.server_data[locale] = response.data;
            try {
                window.localStorage?.setItem('last_configuration', JSON.stringify(configurationData));
            } catch {}
        }
    }

    window.reminder = createApp({
        components: {
            SavedConfigurationReminder,
        },
        template: `
            <SavedConfigurationReminder
                :material="material"
                :image="image"
                :link="link"
                :productType="productType"
                :dimensions="dimensions"
            />
        `,
        setup() {
            return {
                material: configurationData.server_data[locale].material_name,
                image: configurationData.server_data[locale].image,
                link: configurationData.server_data[locale].link,
                productType: configurationData.server_data[locale].product_type,
                dimensions: configurationData.server_data[locale].dimensions,
            };
        },
    });

    window.reminder.use(i18n);
    window.reminder.mount('#' + elementId);

    return true;
};

const closeReminder = () => {
    Cookies.set('reminder_closed', '1', 24);
};

const checkReminderDelay = (time) => {
    if (!time) {
        return true;
    }

    return (time + 3600000) < (new Date()).getTime();
};

const recalculatePosition = () => {
    const reminder = document.getElementById('reminder-wrapper');
    const header = document.querySelector('header#header').clientHeight;
    if (reminder !== null) {
        reminder.style.top = (header + 35)+ 'px';
    }
}
